import { Extension } from '@tiptap/core'
import { Plugin, PluginKey } from '@tiptap/pm/state'

/**
 * Matches non-breaking spaces and similar invisible Unicode characters.
 * @see https://stackoverflow.com/a/51399843/237889
 */
const nbspRegex = /[\u00A0\u180E\u2000-\u200B\u202F\u205F\u3000\uFEFF]/

/**
 * Normalizes text from input or outside sources.
 *
 * Currently, the only rule is to convert non-breaking spaces to regular spaces.
 */
export const Normalize = Extension.create({
  name: 'normalize',

  addProseMirrorPlugins() {
    return [
      new Plugin({
        key: new PluginKey('normalize'),
        props: {
          transformPastedHTML: (html) =>
            html.replace(new RegExp(nbspRegex.source + '|&nbsp;', 'g'), ' '),
          transformPastedText: (text) =>
            text.replace(new RegExp(nbspRegex.source, 'g'), ' '),
        },
      }),
    ]
  },
})
